/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API76174Req {
  
  /** 批次编号 */
  batchNo?: string;
  /** 岗位 */
  position?: string;
  /** 任务名称 */
  taskName?: string;
  /** 开始时间 */
  startTime?: string;
  /** 结束时间 */
  endTime?: string;
  exuteUserNo?: string;
};



export type API76174Res = {};


// 接口函数 76174 增加任务节点

export interface IUsePostAPI76174Return {
  /** 增加任务节点: 接口请求状态 */
  isAPI76174Loading: boolean;
  /** 增加任务节点: 接口请求返回数据 */
  dataAPI76174: API76174Res;
  /**  增加任务节点: 接口数据请求方法 */
  fetchAPI76174Data: (inputs: API76174Req, config?: YWRequestConfig) => Promise<API76174Res>;
  /** 增加任务节点: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76174 = ():IUsePostAPI76174Return => {
  let isMount = true;
  const [isAPI76174Loading, setIsAPI76174Loading] = useState(false);
  const [dataAPI76174, setDataAPI76174] = useState<API76174Res>({} as API76174Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/add/node`;

  const fetchAPI76174Data = async (inputs: API76174Req, config?: YWRequestConfig): Promise<API76174Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76174Req>) || {}) as API76174Req;
    
  
    if ( isMount ) {
      setIsAPI76174Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76174Res>(`${basePath}/yoaichat-web/task/instance/add/node`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76174(res || {} as API76174Res);
        setIsAPI76174Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76174Loading(false);
      }
      return false as unknown as API76174Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76174Loading,
    dataAPI76174,
    fetchAPI76174Data,
    requestUrl,
  }
}

